import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppDialog from "../../Dialogs/AppDialog/AppDialog";
import { KNOWLEDGE_BASE_LIST_PATH } from "../../../Pages/KnowledgeBase/knowledgeBaseConstants";
import { KnowledgeArticleEmbedContent } from "./KnowledgeArticleEmbedBody";
import { useKnowledgeArticleEmbed } from "./useKnowledgeArticleEmbed";
import "./KnowledgeArticleEmbedDialog.scss";

interface KnowledgeArticleEmbedDialogProps {
    articleUuid: string | null;
    sectionIdentifiers?: string[] | null;
    onHide: () => void;
}

const KnowledgeArticleEmbedDialog: React.FC<KnowledgeArticleEmbedDialogProps> = ({
    articleUuid,
    sectionIdentifiers,
    onHide,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const embed = useKnowledgeArticleEmbed(articleUuid);

    const openArticle = () => {
        if (!articleUuid) {
            return;
        }
        onHide();
        navigate(`${KNOWLEDGE_BASE_LIST_PATH}/${articleUuid}`);
    };

    return (
        <AppDialog
            visible={Boolean(articleUuid)}
            onHide={onHide}
            header={embed.article?.title || (t("knowledgeBase.relations.linkedArticles") as string)}
            className="knowledge-article-embed-dialog"
            style={{ width: "min(96vw, 52rem)" }}
            footerActions={{
                cancelLabel: t("common.action.cancel") as string,
                onCancel: onHide,
                secondaryActions: [
                    {
                        label: t("knowledgeBase.relations.openArticle") as string,
                        onClick: openArticle,
                        icon: "pi pi-external-link",
                        disabled: !articleUuid,
                    },
                ],
                submitLabel: t("common.action.close") as string,
                onSubmit: onHide,
            }}
        >
            <KnowledgeArticleEmbedContent embed={embed} sectionIdentifiers={sectionIdentifiers} />
        </AppDialog>
    );
};

export default KnowledgeArticleEmbedDialog;
